import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { Associates } from 'types/customers'
import { WithPaginationApiResponse } from 'types/pagination'

export const getAssociates = (
  customerReference: string
): Promise<WithPaginationApiResponse<Associates[]>> => {
  return requestApi({
    url: `/platform/v2/customers/${customerReference}/associates`,
    method: 'GET',
    baseUrl: BASE_API_URL,
  })
}
